(function () {
  'use strict';

  const INITIAL_LOAD_PAGES = 1;
  const BACKGROUND_BATCH_SIZE = 6;
  const FILTER_REBUILD_DEBOUNCE = 1000;
  const CACHE_TTL = 5 * 60000;
  const PAGINATE_BY = 50;
  const MAX_CACHE_BYTES = 4 * 1024 * 1024;
  const PARALLEL_RETRY_ATTEMPTS = 3;
  const SEQUENTIAL_RETRY_ATTEMPTS = 5;
  const PRICE_FILTER_KEY = 'price';
  const DEFAULT_PER_PAGE = 48;

  // ══════════════════════════════════════════════════════════════════
  //  MODEL ORDER — custom.modell filter values sorted by THIS list.
  //  Upar wala = pehle show hoga (latest first).
  //  Naya model aaye → sirf apni jagah par line add karo.
  //  Matching: case/space/dash/brackets ignore. "Samsung", "Galaxy",
  //  "Apple", "Google", "Sony" words ignore. "+" = "Plus".
  //  Jo value list mein na mile → list ke END mein (A-Z), aur browser
  //  console mein "[DMF] Unlisted models" ke naam se print hoti hai.
  // ══════════════════════════════════════════════════════════════════
  const MODEL_ORDER = [
    // ───────────── APPLE iPhone ─────────────
    'iPhone Ultra', 'iPhone Fold',
    'iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone Air 2', 'iPhone 18', 'iPhone 18e',
    'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone Air', 'iPhone 17', 'iPhone 17e',
    'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e',
    'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
    'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
    'iPhone SE 2022', 'iPhone SE 3',
    'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 Mini',
    'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12', 'iPhone 12 Mini',
    'iPhone SE 2020', 'iPhone SE 2',
    'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11',
    'iPhone XS Max', 'iPhone XS', 'iPhone XR', 'iPhone X',
    'iPhone 8 Plus', 'iPhone 8', 'iPhone 7 Plus', 'iPhone 7',
    'iPhone SE 2016', 'iPhone SE',
    'iPhone 6s Plus', 'iPhone 6s', 'iPhone 6 Plus', 'iPhone 6',
    'iPhone 5s', 'iPhone 5c', 'iPhone 5', 'iPhone 4s', 'iPhone 4', 'iPhone 3GS', 'iPhone 3G',

    // ───────────── APPLE iPad ─────────────
    'iPad Pro 13 M5', 'iPad Pro 13 2025', 'iPad Pro 11 M5', 'iPad Pro 11 2025',
    'iPad Pro 13 M4', 'iPad Pro 13 2024', 'iPad Pro 13', 'iPad Pro 11 M4', 'iPad Pro 11 2024',
    'iPad Pro 12.9 2022', 'iPad Pro 12.9 6', 'iPad Pro 11 2022', 'iPad Pro 11 4',
    'iPad Pro 12.9 2021', 'iPad Pro 12.9 5', 'iPad Pro 11 2021', 'iPad Pro 11 3',
    'iPad Pro 12.9 2020', 'iPad Pro 12.9 4', 'iPad Pro 11 2020', 'iPad Pro 11 2',
    'iPad Pro 12.9 2018', 'iPad Pro 12.9 3', 'iPad Pro 11 2018', 'iPad Pro 11',
    'iPad Pro 12.9 2017', 'iPad Pro 12.9 2', 'iPad Pro 10.5',
    'iPad Pro 12.9 2015', 'iPad Pro 12.9', 'iPad Pro 9.7', 'iPad Pro',
    'iPad Air 13 M4', 'iPad Air 13 2026', 'iPad Air 11 M4', 'iPad Air 11 2026',
    'iPad Air 13 M3', 'iPad Air 13 2025', 'iPad Air 11 M3', 'iPad Air 11 2025',
    'iPad Air 13 M2', 'iPad Air 13 2024', 'iPad Air 13', 'iPad Air 11 M2', 'iPad Air 11 2024', 'iPad Air 11',
    'iPad Air 5', 'iPad Air 2022', 'iPad Air 4', 'iPad Air 2020', 'iPad Air 3', 'iPad Air 2019',
    'iPad Air 2', 'iPad Air',
    'iPad Mini 7', 'iPad Mini 2024', 'iPad Mini A17 Pro', 'iPad Mini 6', 'iPad Mini 2021',
    'iPad Mini 5', 'iPad Mini 2019', 'iPad Mini 4', 'iPad Mini 3', 'iPad Mini 2', 'iPad Mini',
    'iPad 11', 'iPad 2025', 'iPad A16', 'iPad 10', 'iPad 2022', 'iPad 10.9',
    'iPad 9', 'iPad 2021', 'iPad 10.2 2021', 'iPad 8', 'iPad 2020', 'iPad 10.2 2020',
    'iPad 7', 'iPad 2019', 'iPad 10.2 2019', 'iPad 10.2',
    'iPad 6', 'iPad 2018', 'iPad 9.7 2018', 'iPad 5', 'iPad 2017', 'iPad 9.7 2017', 'iPad 9.7',
    'iPad 4', 'iPad 3', 'iPad 2', 'iPad',

    // ───────────── APPLE Watch / iPod ─────────────
    'Watch Ultra 4', 'Watch Ultra 3', 'Watch Ultra 2', 'Watch Ultra',
    'Watch Series 12', 'Watch Series 11', 'Watch Series 10', 'Watch SE 3', 'Watch Series 9',
    'Watch Series 8', 'Watch SE 2', 'Watch Series 7', 'Watch Series 6', 'Watch SE',
    'Watch Series 5', 'Watch Series 4', 'Watch Series 3', 'Watch Series 2', 'Watch Series 1', 'Watch',
    'iPod Touch 7', 'iPod Touch 6', 'iPod Touch 5', 'iPod Touch',

    // ───────────── SAMSUNG S ─────────────
    'S26 Ultra', 'S26 Plus', 'S26',
    'S25 Ultra', 'S25 Edge', 'S25 Plus', 'S25', 'S25 FE',
    'S24 Ultra', 'S24 Plus', 'S24', 'S24 FE',
    'S23 Ultra', 'S23 Plus', 'S23', 'S23 FE',
    'S22 Ultra', 'S22 Plus', 'S22',
    'S21 Ultra', 'S21 Plus', 'S21', 'S21 FE',
    'S20 Ultra', 'S20 Plus', 'S20', 'S20 FE',
    'S10 5G', 'S10 Plus', 'S10', 'S10e', 'S10 Lite',
    'S9 Plus', 'S9', 'S8 Plus', 'S8', 'S8 Active',
    'S7 Edge', 'S7', 'S6 Edge Plus', 'S6 Edge', 'S6',
    'S5 Neo', 'S5 Mini', 'S5', 'S4 Mini', 'S4', 'S3 Mini', 'S3', 'S2 Plus', 'S2',

    // ───────────── SAMSUNG Z (Foldables) ─────────────
    'Z Fold8 Ultra', 'Z Fold8', 'Z Flip8', 'Z TriFold',
    'Z Fold7', 'Z Flip7', 'Z Flip7 FE',
    'Z Fold6', 'Z Flip6', 'Z Fold5', 'Z Flip5', 'Z Fold4', 'Z Flip4',
    'Z Fold3', 'Z Flip3', 'Z Fold2', 'Z Flip 5G', 'Z Flip', 'Fold',

    // ───────────── SAMSUNG Note ─────────────
    'Note 20 Ultra', 'Note 20', 'Note 10 Plus', 'Note 10', 'Note 10 Lite',
    'Note 9', 'Note 8', 'Note FE', 'Note 7', 'Note 5', 'Note 4', 'Note Edge',
    'Note 3 Neo', 'Note 3', 'Note 2', 'Note',

    // ───────────── SAMSUNG A (latest year first) ─────────────
    'A57', 'A37', 'A27', 'A17',                                   // 2026
    'A56', 'A36', 'A26', 'A16', 'A07',                            // 2025
    'A55', 'A35', 'A25', 'A15', 'A06',                            // 2024
    'A54', 'A34', 'A24', 'A14', 'A05s', 'A05',                    // 2023
    'A73', 'A53', 'A33', 'A23', 'A13', 'A04s', 'A04e', 'A04', 'A03 Core', 'A03', // 2022
    'A72', 'A52s', 'A52', 'A42', 'A32', 'A22', 'A12', 'A03s', 'A02s', 'A02',     // 2021
    'A71', 'A51', 'A41', 'A31', 'A21s', 'A21', 'A11', 'A01 Core', 'A01',         // 2020
    'A90', 'A80', 'A70', 'A60', 'A50s', 'A50', 'A40', 'A30s', 'A30',
    'A20s', 'A20e', 'A20', 'A10s', 'A10e', 'A10',                                 // 2019
    'A9 2018', 'A8s', 'A7 2018', 'A6 Plus', 'A6', 'A8 Plus', 'A8 2018',           // 2018
    'A7 2017', 'A5 2017', 'A3 2017',                                              // 2017
    'A9 Pro', 'A9 2016', 'A7 2016', 'A5 2016', 'A3 2016',                         // 2016
    'A9', 'A8', 'A7', 'A5', 'A3',                                                 // 2015

    // ───────────── SAMSUNG M / J / Xcover / Others ─────────────
    'M56', 'M55', 'M35', 'M15', 'M54', 'M34', 'M14', 'M53', 'M33', 'M23', 'M13',
    'M52', 'M32', 'M22', 'M12', 'M51', 'M31s', 'M31', 'M21', 'M11', 'M30s', 'M30', 'M20', 'M10',
    'J8', 'J7 2018', 'J6 Plus', 'J6', 'J4 Plus', 'J4', 'J2 Core',
    'J7 2017', 'J5 2017', 'J3 2017', 'J7 2016', 'J5 2016', 'J3 2016', 'J7', 'J5', 'J3', 'J2', 'J1',
    'Xcover 7 Pro', 'Xcover 7', 'Xcover 6 Pro', 'Xcover 5', 'Xcover Pro', 'Xcover 4s', 'Xcover 4', 'Xcover 3', 'Xcover',
    'Grand Prime', 'Core Prime', 'Alpha',

    // ───────────── SAMSUNG Tab ─────────────
    'Tab S11 Ultra', 'Tab S11', 'Tab S10 Ultra', 'Tab S10 Plus', 'Tab S10 FE Plus', 'Tab S10 FE', 'Tab S10',
    'Tab S9 Ultra', 'Tab S9 Plus', 'Tab S9', 'Tab S9 FE Plus', 'Tab S9 FE',
    'Tab S8 Ultra', 'Tab S8 Plus', 'Tab S8', 'Tab S7 FE', 'Tab S7 Plus', 'Tab S7',
    'Tab S6 Lite', 'Tab S6', 'Tab S5e', 'Tab S4', 'Tab S3', 'Tab S2',
    'Tab A11', 'Tab A9 Plus', 'Tab A9', 'Tab A8', 'Tab A7 Lite', 'Tab A7', 'Tab A 10.1', 'Tab A', 'Tab E', 'Tab 4', 'Tab 3',

    // ───────────── GOOGLE ─────────────
    'Pixel 11 Pro Fold', 'Pixel 11 Pro XL', 'Pixel 11 Pro', 'Pixel 11', 'Pixel 10a',
    'Pixel 10 Pro Fold', 'Pixel 10 Pro XL', 'Pixel 10 Pro', 'Pixel 10', 'Pixel 9a',
    'Pixel 9 Pro Fold', 'Pixel 9 Pro XL', 'Pixel 9 Pro', 'Pixel 9', 'Pixel 8a',
    'Pixel 8 Pro', 'Pixel 8', 'Pixel Fold', 'Pixel 7a', 'Pixel 7 Pro', 'Pixel 7',
    'Pixel 6a', 'Pixel 6 Pro', 'Pixel 6', 'Pixel 5a', 'Pixel 5', 'Pixel 4a 5G', 'Pixel 4a',
    'Pixel 4 XL', 'Pixel 4', 'Pixel 3a XL', 'Pixel 3a', 'Pixel 3 XL', 'Pixel 3',
    'Pixel 2 XL', 'Pixel 2', 'Pixel XL', 'Pixel', 'Nexus 6P', 'Nexus 6', 'Nexus 5X', 'Nexus 5',

    // ───────────── HUAWEI / HONOR ─────────────
    'Huawei Pura 80 Ultra', 'Huawei Pura 80 Pro', 'Huawei Pura 80',
    'Huawei Mate 80 Pro', 'Huawei Mate 80', 'Huawei Mate X6', 'Huawei Mate 70 Pro', 'Huawei Mate 70',
    'Huawei Pura 70 Ultra', 'Huawei Pura 70 Pro', 'Huawei Pura 70',
    'Huawei Mate 60 Pro', 'Huawei Mate 60', 'Huawei P60 Pro', 'Huawei P60',
    'Huawei Mate 50 Pro', 'Huawei Mate 50', 'Huawei P50 Pro', 'Huawei P50 Pocket', 'Huawei P50',
    'Huawei Mate 40 Pro', 'Huawei Mate 40', 'Huawei P40 Pro Plus', 'Huawei P40 Pro', 'Huawei P40',
    'Huawei P40 Lite E', 'Huawei P40 Lite', 'Huawei Mate 30 Pro', 'Huawei Mate 30',
    'Huawei P30 Pro', 'Huawei P30', 'Huawei P30 Lite',
    'Huawei Mate 20 Pro', 'Huawei Mate 20 X', 'Huawei Mate 20 Lite', 'Huawei Mate 20',
    'Huawei P20 Pro', 'Huawei P20 Lite', 'Huawei P20',
    'Huawei Mate 10 Pro', 'Huawei Mate 10 Lite', 'Huawei Mate 10',
    'Huawei P10 Plus', 'Huawei P10 Lite', 'Huawei P10', 'Huawei Mate 9',
    'Huawei P9 Plus', 'Huawei P9 Lite', 'Huawei P9', 'Huawei Mate 8', 'Huawei P8 Lite', 'Huawei P8', 'Huawei Mate 7',
    'Huawei Nova 12', 'Huawei Nova 11', 'Huawei Nova 10', 'Huawei Nova 9', 'Huawei Nova 8',
    'Huawei Nova 5T', 'Huawei Nova 3', 'Huawei Nova 2', 'Huawei Nova',
    'Huawei P Smart 2021', 'Huawei P Smart 2020', 'Huawei P Smart Pro', 'Huawei P Smart Z',
    'Huawei P Smart 2019', 'Huawei P Smart Plus', 'Huawei P Smart',
    'Huawei Y9 2019', 'Huawei Y9', 'Huawei Y7 2019', 'Huawei Y7', 'Huawei Y6p', 'Huawei Y6 2019', 'Huawei Y6',
    'Huawei Y5 2019', 'Huawei Y5',
    'Honor 90', 'Honor 70', 'Honor 50', 'Honor 20', 'Honor View 20', 'Honor 10', 'Honor 9', 'Honor 8', 'Honor Play',

    // ───────────── OPPO ─────────────
    'Oppo Find X9 Ultra', 'Oppo Find X9 Pro', 'Oppo Find X9', 'Oppo Find X8 Ultra', 'Oppo Find X8 Pro', 'Oppo Find X8',
    'Oppo Find N5', 'Oppo Find X7 Ultra', 'Oppo Find X6 Pro', 'Oppo Find N3', 'Oppo Find N2 Flip',
    'Oppo Find X5 Pro', 'Oppo Find X5 Lite', 'Oppo Find X5', 'Oppo Find X3 Pro', 'Oppo Find X3 Neo', 'Oppo Find X3 Lite', 'Oppo Find X3',
    'Oppo Find X2 Pro', 'Oppo Find X2 Neo', 'Oppo Find X2 Lite', 'Oppo Find X2', 'Oppo Find X',
    'Oppo Reno 15 Pro', 'Oppo Reno 15', 'Oppo Reno 14 Pro', 'Oppo Reno 14 F', 'Oppo Reno 14',
    'Oppo Reno 13 Pro', 'Oppo Reno 13 F', 'Oppo Reno 13', 'Oppo Reno 12 Pro', 'Oppo Reno 12 F', 'Oppo Reno 12',
    'Oppo Reno 11 Pro', 'Oppo Reno 11 F', 'Oppo Reno 11', 'Oppo Reno 10 Pro Plus', 'Oppo Reno 10 Pro', 'Oppo Reno 10',
    'Oppo Reno 8 Pro', 'Oppo Reno 8 Lite', 'Oppo Reno 8T', 'Oppo Reno 8', 'Oppo Reno 7', 'Oppo Reno 6 Pro', 'Oppo Reno 6',
    'Oppo Reno 5 Pro', 'Oppo Reno 5', 'Oppo Reno 4 Pro', 'Oppo Reno 4 Z', 'Oppo Reno 4',
    'Oppo Reno 3', 'Oppo Reno 2 Z', 'Oppo Reno 2', 'Oppo Reno',
    'Oppo A6 Pro', 'Oppo A5 Pro', 'Oppo A98', 'Oppo A80', 'Oppo A79', 'Oppo A78', 'Oppo A60', 'Oppo A58', 'Oppo A38', 'Oppo A18',
    'Oppo A96', 'Oppo A94', 'Oppo A77', 'Oppo A76', 'Oppo A74', 'Oppo A57', 'Oppo A54s', 'Oppo A54',
    'Oppo A17', 'Oppo A16s', 'Oppo A16', 'Oppo A15s', 'Oppo A15',
    'Oppo A91', 'Oppo A73', 'Oppo A72', 'Oppo A53s', 'Oppo A53', 'Oppo A52', 'Oppo A32', 'Oppo A31',
    'Oppo A9 2020', 'Oppo A5 2020', 'Oppo A9', 'Oppo A5', 'Oppo A3',

    // ───────────── XIAOMI / REDMI / POCO ─────────────
    'Xiaomi 17 Ultra', 'Xiaomi 17 Pro Max', 'Xiaomi 17 Pro', 'Xiaomi 17',
    'Xiaomi 15T Pro', 'Xiaomi 15T', 'Xiaomi 15 Ultra', 'Xiaomi 15',
    'Xiaomi 14T Pro', 'Xiaomi 14T', 'Xiaomi 14 Ultra', 'Xiaomi 14',
    'Xiaomi 13T Pro', 'Xiaomi 13T', 'Xiaomi 13 Ultra', 'Xiaomi 13 Pro', 'Xiaomi 13 Lite', 'Xiaomi 13',
    'Xiaomi 12T Pro', 'Xiaomi 12T', 'Xiaomi 12 Pro', 'Xiaomi 12 Lite', 'Xiaomi 12X', 'Xiaomi 12',
    'Xiaomi 11T Pro', 'Xiaomi 11T', 'Xiaomi 11 Lite 5G NE',
    'Mi 11 Ultra', 'Mi 11i', 'Mi 11 Lite', 'Mi 11',
    'Mi 10T Pro', 'Mi 10T Lite', 'Mi 10T', 'Mi 10 Pro', 'Mi 10 Lite', 'Mi 10',
    'Mi Note 10 Pro', 'Mi Note 10 Lite', 'Mi Note 10',
    'Mi 9T Pro', 'Mi 9T', 'Mi 9 SE', 'Mi 9 Lite', 'Mi 9', 'Mi A3', 'Mi Mix 3', 'Mi 8 Lite', 'Mi 8',
    'Mi Mix 2s', 'Mi A2 Lite', 'Mi A2', 'Mi Mix 2', 'Mi A1', 'Mi 6',
    'Redmi Note 15 Pro Plus', 'Redmi Note 15 Pro', 'Redmi Note 15',
    'Redmi Note 14 Pro Plus', 'Redmi Note 14 Pro', 'Redmi Note 14',
    'Redmi Note 13 Pro Plus', 'Redmi Note 13 Pro', 'Redmi Note 13',
    'Redmi Note 12 Pro Plus', 'Redmi Note 12 Pro', 'Redmi Note 12S', 'Redmi Note 12',
    'Redmi Note 11 Pro Plus', 'Redmi Note 11 Pro', 'Redmi Note 11S', 'Redmi Note 11',
    'Redmi Note 10 Pro', 'Redmi Note 10S', 'Redmi Note 10 5G', 'Redmi Note 10',
    'Redmi Note 9 Pro', 'Redmi Note 9S', 'Redmi Note 9T', 'Redmi Note 9',
    'Redmi Note 8 Pro', 'Redmi Note 8T', 'Redmi Note 8', 'Redmi Note 7', 'Redmi Note 6 Pro', 'Redmi Note 5', 'Redmi Note 4',
    'Redmi 15', 'Redmi 14C', 'Redmi 13C', 'Redmi 13', 'Redmi 12C', 'Redmi 12', 'Redmi 10C', 'Redmi 10',
    'Redmi 9T', 'Redmi 9C', 'Redmi 9A', 'Redmi 9', 'Redmi 8A', 'Redmi 8', 'Redmi 7A', 'Redmi 7', 'Redmi 6A', 'Redmi 6',
    'Poco F7 Pro', 'Poco F7', 'Poco X7 Pro', 'Poco X7', 'Poco F6 Pro', 'Poco F6', 'Poco X6 Pro', 'Poco X6',
    'Poco F5 Pro', 'Poco F5', 'Poco X5 Pro', 'Poco X5', 'Poco F4 GT', 'Poco F4', 'Poco X4 Pro', 'Poco M5',
    'Poco M4 Pro', 'Poco F3', 'Poco X3 Pro', 'Poco X3 NFC', 'Poco X3', 'Poco M3', 'Poco F2 Pro', 'Poco F1',

    // ───────────── SONY ─────────────
    'Xperia 1 VIII', 'Xperia 10 VIII', 'Xperia 1 VII', 'Xperia 10 VII', 'Xperia 1 VI', 'Xperia 10 VI',
    'Xperia 5 V', 'Xperia 1 V', 'Xperia 10 V', 'Xperia 5 IV', 'Xperia 1 IV', 'Xperia 10 IV',
    'Xperia 5 III', 'Xperia 1 III', 'Xperia 10 III', 'Xperia 5 II', 'Xperia 1 II', 'Xperia 10 II',
    'Xperia 5', 'Xperia 1', 'Xperia 10 Plus', 'Xperia 10',
    'Xperia XZ3', 'Xperia XZ2 Premium', 'Xperia XZ2 Compact', 'Xperia XZ2', 'Xperia XA2 Ultra', 'Xperia XA2 Plus', 'Xperia XA2', 'Xperia L2',
    'Xperia XZ1 Compact', 'Xperia XZ1', 'Xperia XZ Premium', 'Xperia XA1 Ultra', 'Xperia XA1 Plus', 'Xperia XA1', 'Xperia L1',
    'Xperia XZs', 'Xperia XZ', 'Xperia X Compact', 'Xperia X Performance', 'Xperia XA Ultra', 'Xperia XA', 'Xperia X',
    'Xperia Z5 Premium', 'Xperia Z5 Compact', 'Xperia Z5', 'Xperia Z3 Plus', 'Xperia Z3 Compact', 'Xperia Z3',
    'Xperia Z2', 'Xperia Z1 Compact', 'Xperia Z1', 'Xperia Z', 'Xperia M5', 'Xperia M4 Aqua', 'Xperia E5',

    // ───────────── MOTOROLA ─────────────
    'Motorola Razr 60 Ultra', 'Motorola Razr 60', 'Motorola Razr 50 Ultra', 'Motorola Razr 50',
    'Motorola Razr 40 Ultra', 'Motorola Razr 40', 'Motorola Razr 5G', 'Motorola Razr',
    'Motorola Edge 60 Pro', 'Motorola Edge 60 Fusion', 'Motorola Edge 60',
    'Motorola Edge 50 Ultra', 'Motorola Edge 50 Pro', 'Motorola Edge 50 Fusion', 'Motorola Edge 50',
    'Motorola Edge 40 Pro', 'Motorola Edge 40 Neo', 'Motorola Edge 40',
    'Motorola Edge 30 Ultra', 'Motorola Edge 30 Pro', 'Motorola Edge 30 Neo', 'Motorola Edge 30 Fusion', 'Motorola Edge 30',
    'Motorola Edge 20 Pro', 'Motorola Edge 20 Lite', 'Motorola Edge 20', 'Motorola Edge Plus', 'Motorola Edge',
    'Moto G86', 'Moto G85', 'Moto G84', 'Moto G75', 'Moto G73', 'Moto G72', 'Moto G71', 'Moto G62', 'Moto G60',
    'Moto G56', 'Moto G55', 'Moto G54', 'Moto G53', 'Moto G52', 'Moto G51', 'Moto G50',
    'Moto G42', 'Moto G41', 'Moto G35', 'Moto G34', 'Moto G32', 'Moto G31', 'Moto G30',
    'Moto G24', 'Moto G23', 'Moto G22', 'Moto G15', 'Moto G14', 'Moto G13', 'Moto G10', 'Moto G05', 'Moto G04',
    'Moto G9 Plus', 'Moto G9 Power', 'Moto G9 Play', 'Moto G9', 'Moto G8 Plus', 'Moto G8 Power', 'Moto G8',
    'Moto G7 Plus', 'Moto G7 Power', 'Moto G7 Play', 'Moto G7', 'Moto G6 Plus', 'Moto G6 Play', 'Moto G6',
    'Moto G5S Plus', 'Moto G5S', 'Moto G5 Plus', 'Moto G5', 'Moto G4 Plus', 'Moto G4', 'Moto G3', 'Moto G2', 'Moto G',
    'Moto E40', 'Moto E32', 'Moto E22', 'Moto E20', 'Moto E13', 'Moto E7', 'Moto E6', 'Moto E5', 'Moto E4', 'Moto E',
    'Moto Z4', 'Moto Z3', 'Moto Z2', 'Moto Z', 'Moto X4', 'Moto X',

    // ───────────── NOKIA ─────────────
    'Nokia XR21', 'Nokia X30', 'Nokia G60', 'Nokia G42', 'Nokia G22', 'Nokia C32', 'Nokia C22', 'Nokia C12',
    'Nokia XR20', 'Nokia X20', 'Nokia X10', 'Nokia G21', 'Nokia G20', 'Nokia G11', 'Nokia G10', 'Nokia C21', 'Nokia C20',
    'Nokia 8.3', 'Nokia 5.4', 'Nokia 5.3', 'Nokia 3.4', 'Nokia 2.4', 'Nokia 1.4',
    'Nokia 9', 'Nokia 8.1', 'Nokia 7.2', 'Nokia 7.1', 'Nokia 6.2', 'Nokia 6.1', 'Nokia 5.1', 'Nokia 4.2',
    'Nokia 3.2', 'Nokia 3.1', 'Nokia 2.3', 'Nokia 2.2', 'Nokia 2.1', 'Nokia 1 Plus',
    'Nokia 8 Sirocco', 'Nokia 8', 'Nokia 7 Plus', 'Nokia 7', 'Nokia 6', 'Nokia 5', 'Nokia 3', 'Nokia 2', 'Nokia 1',
    'Nokia Lumia 950 XL', 'Nokia Lumia 950', 'Nokia Lumia 930', 'Nokia Lumia 830', 'Nokia Lumia 640 XL', 'Nokia Lumia 640',
    'Nokia Lumia 630', 'Nokia Lumia 535', 'Nokia Lumia',

    // ───────────── LG ─────────────
    'LG Wing', 'LG Velvet', 'LG V60', 'LG K62', 'LG K52', 'LG K42', 'LG K61', 'LG K51s', 'LG K41s',
    'LG G8X', 'LG G8s', 'LG G8', 'LG V50', 'LG K50s', 'LG K40s', 'LG Q60', 'LG K50', 'LG K40',
    'LG G7', 'LG V40', 'LG Q7', 'LG K11', 'LG V30', 'LG G6', 'LG Q6', 'LG K10 2017', 'LG K8 2017', 'LG K4 2017',
    'LG V20', 'LG G5', 'LG K10', 'LG K8', 'LG K4', 'LG V10', 'LG G4', 'LG G3', 'LG G2',

    // ───────────── HTC ─────────────
    'HTC U23 Pro', 'HTC U20', 'HTC U19e', 'HTC U12 Plus', 'HTC U12 Life', 'HTC U11 Plus', 'HTC U11 Life', 'HTC U11',
    'HTC U Ultra', 'HTC U Play', 'HTC 10', 'HTC One A9s', 'HTC One A9', 'HTC One M9 Plus', 'HTC One M9',
    'HTC One M8s', 'HTC One M8', 'HTC One Mini 2', 'HTC One M7', 'HTC One Mini', 'HTC One',
    'HTC Desire 22 Pro', 'HTC Desire 21 Pro', 'HTC Desire 20 Pro', 'HTC Desire 19 Plus', 'HTC Desire 12 Plus', 'HTC Desire 12',
    'HTC Desire 10 Pro', 'HTC Desire 10 Lifestyle', 'HTC Desire 830', 'HTC Desire 820', 'HTC Desire 650', 'HTC Desire 626',
    'HTC Desire 620', 'HTC Desire 610', 'HTC Desire 530', 'HTC Desire 510', 'HTC Desire 500', 'HTC Desire',
  ];

  // Brand-less values (e.g. "P30 Pro" in Huawei collection) ke liye 2nd try
  const MODEL_BRAND_PREFIXES = ['huawei', 'oppo', 'xiaomi', 'htc', 'lg', 'nokia', 'moto'];

  function normalizeModel(str) {
    return String(str == null ? '' : str)
      .toLowerCase()
      .replace(/\+/g, ' plus ')
      .replace(/\bwatch\s*series\b/g, 'watch')
      .replace(/\bxiaomi\s+(?=(redmi|poco|mi)\b)/g, '')
      .replace(/\bhuawei\s+(?=honor\b)/g, '')
      .replace(/\bmotorola\s+moto\b/g, 'moto')
      .replace(/\bmotorola\b/g, 'moto')
      .replace(/\b(samsung|galaxy|apple|google|sony)\b/g, ' ')
      .replace(/[^a-z0-9]/g, '');
  }

  // Normalized key → rank (first occurrence wins)
  const MODEL_RANK = new Map();
  MODEL_ORDER.forEach((name, i) => {
    const k = normalizeModel(name);
    if (k && !MODEL_RANK.has(k)) MODEL_RANK.set(k, i);
  });
  const MODEL_KEYS = Array.from(MODEL_RANK.keys());

  // Exact match → rank. Warna longest list-entry jo value ka shuru ho.
  function matchModelKey(norm) {
    if (MODEL_RANK.has(norm)) return { rank: MODEL_RANK.get(norm), exact: true };
    let best = null;
    for (const k of MODEL_KEYS) {
      if (norm.startsWith(k) && (!best || k.length > best.length)) best = k;
    }
    return best ? { rank: MODEL_RANK.get(best), exact: false } : null;
  }

  const _modelRankCache = new Map();
  function getModelRank(value) {
    if (_modelRankCache.has(value)) return _modelRankCache.get(value);
    const norm = normalizeModel(value);
    let res = norm ? matchModelKey(norm) : null;
    if (!res && norm) {
      for (const p of MODEL_BRAND_PREFIXES) {
        res = matchModelKey(p + norm);
        if (res) break;
      }
    }
    _modelRankCache.set(value, res);
    return res;
  }

  class DynamicMetafieldFilter {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.sectionId = wrapper.dataset.dmfSection;
      this.collectionUrl = wrapper.dataset.collectionUrl;
      this.collectionHandle = wrapper.dataset.collectionHandle;
      this.totalProducts = parseInt(wrapper.dataset.totalProducts, 10) || 0;

      this.filtersEl = document.getElementById(`dmf-filters-${this.sectionId}`);
      this.gridEl = document.getElementById(`dmf-grid-${this.sectionId}`);
      this.countEl = document.getElementById(`dmf-count-${this.sectionId}`);
      this.sortEl = document.getElementById(`dmf-sort-${this.sectionId}`);
      this.perPageEl = document.getElementById(`dmf-perpage-${this.sectionId}`);
      this.paginationEl = document.getElementById(`dmf-pagination-${this.sectionId}`);
      this.emptyEl = document.getElementById(`dmf-empty-${this.sectionId}`);

      this.rangeKeys = (wrapper.dataset.rangeKeys || '').split(',').map(s => s.trim()).filter(Boolean);
      this.hiddenKeys = (wrapper.dataset.hiddenKeys || '').split(',').map(s => s.trim()).filter(Boolean);
      try { this.labels = wrapper.dataset.labels ? JSON.parse(wrapper.dataset.labels) : {}; }
      catch { this.labels = {}; }

      this.products = [];
      this.metafieldMap = {};
      this.priceRange = { min: 0, max: 0 };
      this.activeFilters = {};
      this.currentPage = 1;
      const dataPerPage = parseInt(wrapper.dataset.perPage, 10);
      const validPerPages = [24, 48, 72, 96];
      this.perPage = validPerPages.includes(dataPerPage) ? dataPerPage : DEFAULT_PER_PAGE;
      this.filteredProducts = [];
      this.expectedTotal = this.totalProducts;
      this.totalPages = 1;
      this.isBackgroundLoading = false;

      this.injectStyles();
      this.setupImageObserver();
      this.init();
    }

    injectStyles() {
      if (document.getElementById('dmf-injected-styles')) return;
      const style = document.createElement('style');
      style.id = 'dmf-injected-styles';
      style.textContent = `
        .dmf-skeleton-card { display: block; }
        .dmf-skeleton-img,
        .dmf-skeleton-line {
          background: linear-gradient(90deg, #f0f0f0 0%, #e4e4e4 50%, #f0f0f0 100%);
          background-size: 200% 100%;
          animation: dmfShimmer 1.4s ease-in-out infinite;
        }
        .dmf-skeleton-img { width: 100%; aspect-ratio: 1; border-radius: 4px; }
        .dmf-skeleton-body { padding: 10px 4px; }
        .dmf-skeleton-line { height: 12px; border-radius: 2px; margin-top: 8px; }
        .dmf-skeleton-line-short { width: 40%; }
        @keyframes dmfShimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `;
      document.head.appendChild(style);
    }

    setupImageObserver() {
      if (!('IntersectionObserver' in window)) { this.imageObserver = null; return; }
      this.imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              this.imageObserver.unobserve(img);
            }
          }
        });
      }, { rootMargin: '200px' });
    }

    async init() {
      try {
        const initial = await this.loadInitialProducts();
        this.products = initial.products;
        this.totalPages = initial.totalPages;
        this.expectedTotal = initial.totalProducts || this.totalProducts;

        this.filteredProducts = this.products.slice();
        this.detectMetafields();
        this.detectPriceRange();
        this.buildFilterUI();
        this.bindEvents();
        this.loadFromURL();
        this.applyFilters();

        if (!initial.complete && this.totalPages > INITIAL_LOAD_PAGES) {
          this.loadRemainingProductsInBackground();
        }
      } catch (err) {
        console.error('DMF init failed:', err);
        this.gridEl.innerHTML = `<div class="dmf-empty"><p>Failed to load products. Reload the page.</p></div>`;
        this.filtersEl.innerHTML = '';
      }
    }

    async loadInitialProducts() {
      const cacheKey = `dmf:${this.collectionHandle}`;
      try {
        const cachedRaw = sessionStorage.getItem(cacheKey);
        if (cachedRaw) {
          const cached = JSON.parse(cachedRaw);
          if (
            cached.complete === true &&
            Date.now() - cached.ts < CACHE_TTL &&
            Array.isArray(cached.data) && cached.data.length > 0
          ) {
            return {
              products: cached.data,
              totalPages: cached.totalPages || Math.ceil(cached.data.length / PAGINATE_BY),
              totalProducts: cached.totalProducts || cached.data.length,
              complete: true
            };
          }
        }
      } catch {}

      const initialPages = [];
      for (let p = 1; p <= INITIAL_LOAD_PAGES; p++) initialPages.push(p);

      const results = await Promise.all(initialPages.map(async p => {
        try {
          const data = await this.fetchJsonPageWithRetry(p, PARALLEL_RETRY_ATTEMPTS);
          return { page: p, data };
        } catch (err) {
          return { page: p, error: err };
        }
      }));

      results.sort((a, b) => a.page - b.page);

      let products = [];
      let totalPages = 1;
      let totalProducts = this.totalProducts;
      const failedInitial = [];

      results.forEach(r => {
        if (r.data && Array.isArray(r.data.products)) {
          products = products.concat(r.data.products);
          if (r.data.totalPages) totalPages = r.data.totalPages;
          if (r.data.totalProducts) totalProducts = r.data.totalProducts;
        } else {
          failedInitial.push(r.page);
        }
      });

      for (const p of failedInitial) {
        try {
          const data = await this.fetchJsonPageWithRetry(p, SEQUENTIAL_RETRY_ATTEMPTS);
          if (data && Array.isArray(data.products)) {
            products = products.concat(data.products);
            if (data.totalPages) totalPages = data.totalPages;
            if (data.totalProducts) totalProducts = data.totalProducts;
          }
        } catch (e) {
          console.warn(`DMF: initial page ${p} failed`, e);
        }
      }

      if (products.length === 0) throw new Error('No products loaded in initial fetch');

      return { products, totalPages, totalProducts, complete: false };
    }

    async loadRemainingProductsInBackground() {
      this.isBackgroundLoading = true;
      const start = INITIAL_LOAD_PAGES + 1;
      const remaining = [];
      for (let p = start; p <= this.totalPages; p++) remaining.push(p);

      const failedPages = [];

      for (let i = 0; i < remaining.length; i += BACKGROUND_BATCH_SIZE) {
        const batch = remaining.slice(i, i + BACKGROUND_BATCH_SIZE);
        const batchResults = await Promise.all(batch.map(async p => {
          try {
            const data = await this.fetchJsonPageWithRetry(p, PARALLEL_RETRY_ATTEMPTS);
            return { page: p, data };
          } catch (err) {
            return { page: p, error: err };
          }
        }));

        let added = 0;
        batchResults.forEach(r => {
          if (r.data && Array.isArray(r.data.products)) {
            this.products = this.products.concat(r.data.products);
            added += r.data.products.length;
          } else {
            failedPages.push(r.page);
          }
        });

        if (added > 0) this.scheduleBackgroundUpdate();
      }

      if (failedPages.length > 0) {
        console.warn(`DMF: retrying ${failedPages.length} failed background page(s)`, failedPages);
        for (const p of failedPages) {
          try {
            const data = await this.fetchJsonPageWithRetry(p, SEQUENTIAL_RETRY_ATTEMPTS);
            if (data && Array.isArray(data.products)) {
              this.products = this.products.concat(data.products);
              this.scheduleBackgroundUpdate();
            }
          } catch (e) {
            console.error(`DMF: page ${p} permanently failed`, e);
          }
        }
      }

      this.isBackgroundLoading = false;
      clearTimeout(this._bgUpdateTimer);
      this.runBackgroundUpdate(true);
      this.cacheProducts(true);
      console.info(`DMF: complete — ${this.products.length}/${this.expectedTotal} products loaded`);
    }

    scheduleBackgroundUpdate() {
      clearTimeout(this._bgUpdateTimer);
      this._bgUpdateTimer = setTimeout(() => this.runBackgroundUpdate(), FILTER_REBUILD_DEBOUNCE);
    }

    runBackgroundUpdate(force) {
      if (!force && this.filtersEl.contains(document.activeElement)) {
        this.scheduleBackgroundUpdate();
        return;
      }

      const prevMap = this.metafieldMap;
      const prevPrice = this.priceRange;
      this.detectMetafields();
      this.detectPriceRange();

      if (this.hasNewFilterOptions(prevMap, this.metafieldMap, prevPrice, this.priceRange)) {
        const scrollState = this.captureFilterScrollState();
        this.buildFilterUI();
        this.restoreFilterUIState();
        this.restoreFilterScrollState(scrollState);
      }

      this.applyFilters();
    }

    hasNewFilterOptions(prevMap, newMap, prevPrice, newPrice) {
      const prevKeys = Object.keys(prevMap);
      const newKeys = Object.keys(newMap);
      if (newKeys.length !== prevKeys.length) return true;
      for (const key of newKeys) {
        if (!prevMap[key]) return true;
        if (newMap[key].size !== prevMap[key].size) return true;
      }
      if (prevPrice.min !== newPrice.min || prevPrice.max !== newPrice.max) return true;
      return false;
    }

    captureFilterScrollState() {
      const map = {};
      this.filtersEl.querySelectorAll('.dmf-filter-group').forEach(group => {
        const key = group.dataset.key;
        const list = group.querySelector('.dmf-check-list');
        const search = group.querySelector('.dmf-filter-search');
        const toggle = group.querySelector('.dmf-filter-toggle');
        map[key] = {
          scrollTop: list ? list.scrollTop : 0,
          searchTerm: search ? search.value : '',
          expanded: toggle ? toggle.getAttribute('aria-expanded') !== 'false' : true
        };
      });
      return map;
    }

    restoreFilterScrollState(map) {
      Object.keys(map).forEach(key => {
        const group = this.filtersEl.querySelector(`[data-key="${CSS.escape(key)}"]`);
        if (!group) return;
        const state = map[key];
        const list = group.querySelector('.dmf-check-list');
        const search = group.querySelector('.dmf-filter-search');
        if (list) list.scrollTop = state.scrollTop;
        if (search && state.searchTerm) {
          search.value = state.searchTerm;
          const term = state.searchTerm.toLowerCase();
          if (list) {
            list.querySelectorAll('.dmf-check-item').forEach(item => {
              item.style.display = item.textContent.toLowerCase().includes(term) ? '' : 'none';
            });
          }
        }
        if (!state.expanded) {
          const toggle = group.querySelector('.dmf-filter-toggle');
          const body = group.querySelector('.dmf-filter-body');
          if (toggle && body) {
            toggle.setAttribute('aria-expanded', 'false');
            body.style.display = 'none';
          }
        }
      });
    }

    restoreFilterUIState() {
      Object.keys(this.activeFilters).forEach(key => {
        const f = this.activeFilters[key];
        const group = this.filtersEl.querySelector(`[data-key="${CSS.escape(key)}"]`);
        if (!group) return;
        if (f.type === 'checkbox') {
          f.values.forEach(v => {
            const cb = group.querySelector(`.dmf-check[value="${CSS.escape(v)}"]`);
            if (cb) cb.checked = true;
          });
        } else if (f.type === 'range') {
          const minEl = group.querySelector('.dmf-range-min');
          const maxEl = group.querySelector('.dmf-range-max');
          if (minEl && f.min !== -Infinity) minEl.value = f.min;
          if (maxEl && f.max !== Infinity) maxEl.value = f.max;
        }
      });
    }

    cacheProducts(complete) {
      const cacheKey = `dmf:${this.collectionHandle}`;
      try {
        const payload = {
          ts: Date.now(),
          data: this.products,
          totalPages: this.totalPages,
          totalProducts: this.expectedTotal,
          complete: !!complete
        };
        const serialized = JSON.stringify(payload);
        if (serialized.length <= MAX_CACHE_BYTES) {
          sessionStorage.setItem(cacheKey, serialized);
        } else {
          console.info(`DMF: cache skipped (${(serialized.length / 1024 / 1024).toFixed(1)}MB > 4MB)`);
        }
      } catch (e) {
        console.warn('DMF: cache write failed', e);
      }
    }

    async fetchJsonPageWithRetry(page, maxAttempts) {
      let lastErr;
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
          return await this.fetchJsonPage(page);
        } catch (err) {
          lastErr = err;
          if (attempt < maxAttempts) {
            const base = Math.min(2500, 200 * Math.pow(2, attempt - 1));
            const jitter = Math.random() * 250;
            await new Promise(r => setTimeout(r, base + jitter));
          }
        }
      }
      throw lastErr;
    }

    async fetchJsonPage(page) {
      const url = `${this.collectionUrl}?view=dmf-data&page=${page}`;
      const resp = await fetch(url, {
        headers: { Accept: 'application/json,text/plain,*/*' },
        credentials: 'same-origin'
      });
      if (!resp.ok) throw new Error(`HTTP ${resp.status} on page ${page}`);
      const text = await resp.text();
      const trimmed = text.trim();
      if (!trimmed.startsWith('{')) {
        throw new Error(`Non-JSON response on page ${page} (got ${trimmed.slice(0, 40)}...)`);
      }
      return JSON.parse(trimmed);
    }

    detectMetafields() {
      const map = {};
      this.products.forEach(p => {
        const mf = p.metafields || {};
        Object.keys(mf).forEach(key => {
          if (this.hiddenKeys.includes(key)) return;
          let val = mf[key];
          if (val === null || val === undefined || val === '') return;
          if (typeof val === 'string' && (val.startsWith('[') || val.startsWith('{'))) {
            try { val = JSON.parse(val); } catch {}
          }
          if (!map[key]) map[key] = new Set();
          if (Array.isArray(val)) val.forEach(v => map[key].add(String(v)));
          else if (typeof val === 'object' && val !== null) {
            if (val.value !== undefined) map[key].add(String(val.value));
          } else map[key].add(String(val));
        });
      });
      this.metafieldMap = map;
    }

    detectPriceRange() {
      const prices = this.products
        .map(p => parseFloat(p.price))
        .filter(n => !isNaN(n) && n >= 0);
      if (prices.length === 0) { this.priceRange = { min: 0, max: 0 }; return; }
      this.priceRange = {
        min: Math.floor(Math.min(...prices)),
        max: Math.ceil(Math.max(...prices))
      };
    }

    // ── Filter key priority: modell first, teil_typ second, rest alphabetical ──
    sortFilterKeys(keys) {
      const PRIORITY = ['custom.modell', 'custom.teil_typ'];
      return [...keys].sort((a, b) => {
        const ai = PRIORITY.indexOf(a);
        const bi = PRIORITY.indexOf(b);
        if (ai !== -1 && bi !== -1) return ai - bi;
        if (ai !== -1) return -1;
        if (bi !== -1) return 1;
        return a.localeCompare(b);
      });
    }

    // ── Model sort: MODEL_ORDER list ke hisaab se (latest first) ──
    // List mein na mile → end mein A-Z, aur console mein report
    sortModelValues(values) {
      const unlisted = [];
      const sorted = [...values].sort((a, b) => {
        const ra = getModelRank(a);
        const rb = getModelRank(b);
        if (ra && rb) {
          if (ra.rank !== rb.rank) return ra.rank - rb.rank;
          if (ra.exact !== rb.exact) return ra.exact ? -1 : 1;
          return b.localeCompare(a); // same model: "5G" before "4G"
        }
        if (ra) return -1;
        if (rb) return 1;
        return a.localeCompare(b);
      });
      values.forEach(v => { if (!getModelRank(v)) unlisted.push(v); });
      if (unlisted.length && !this._loggedUnlisted) {
        this._loggedUnlisted = true;
        console.info('[DMF] Unlisted models (add to MODEL_ORDER):', unlisted);
      }
      return sorted;
    }

    buildFilterUI() {
      this.filtersEl.innerHTML = '';
      this.buildPriceFilter();

      const keys = this.sortFilterKeys(Object.keys(this.metafieldMap));
      keys.forEach(key => {
        // custom.modell → smart version sort (latest first)
        // everything else → numeric asc, then alpha
        const rawValues = Array.from(this.metafieldMap[key]);
        const values = key === 'custom.modell'
          ? this.sortModelValues(rawValues)
          : rawValues.sort((a, b) => {
              const na = parseFloat(a), nb = parseFloat(b);
              if (!isNaN(na) && !isNaN(nb)) return na - nb;
              return a.localeCompare(b);
            });

        const label = this.labels[key] || this.humanize(key);
        const isRange = this.rangeKeys.includes(key) && values.every(v => !isNaN(parseFloat(v)));

        const group = document.createElement('div');
        group.className = 'dmf-filter-group';
        group.dataset.key = key;

        if (isRange) {
          const nums = values.map(parseFloat);
          const min = Math.min(...nums), max = Math.max(...nums);
          group.innerHTML = `
            <button class="dmf-filter-toggle" type="button" aria-expanded="true">
              <span>${this.escape(label)}</span><span class="dmf-caret">▾</span>
            </button>
            <div class="dmf-filter-body">
              <div class="dmf-range">
                <input type="number" class="dmf-range-min" placeholder="Min" min="${min}" max="${max}" step="0.01">
                <span>—</span>
                <input type="number" class="dmf-range-max" placeholder="Max" min="${min}" max="${max}" step="0.01">
              </div>
              <small class="dmf-range-hint">Range: ${min} – ${max}</small>
            </div>
          `;
        } else {
          const items = values.map(v => `
            <label class="dmf-check-item">
              <input type="checkbox" class="dmf-check" value="${this.escape(v)}">
              <span>${this.escape(v)}</span>
              <small class="dmf-count" data-value="${this.escape(v)}"></small>
            </label>
          `).join('');

          group.innerHTML = `
            <button class="dmf-filter-toggle" type="button" aria-expanded="true">
              <span>${this.escape(label)}</span><span class="dmf-caret">▾</span>
            </button>
            <div class="dmf-filter-body">
              ${values.length > 8 ? '<input type="text" class="dmf-filter-search" placeholder="Search...">' : ''}
              <div class="dmf-check-list">${items}</div>
            </div>
          `;
        }
        this.filtersEl.appendChild(group);
      });
    }

    buildPriceFilter() {
      if (!this.products.length || this.priceRange.min >= this.priceRange.max) return;
      const { min, max } = this.priceRange;
      const label = this.labels[PRICE_FILTER_KEY] || 'Price';
      const group = document.createElement('div');
      group.className = 'dmf-filter-group dmf-filter-price';
      group.dataset.key = PRICE_FILTER_KEY;
      group.innerHTML = `
        <button class="dmf-filter-toggle" type="button" aria-expanded="true">
          <span>${this.escape(label)}</span><span class="dmf-caret">▾</span>
        </button>
        <div class="dmf-filter-body">
          <div class="dmf-range">
            <input type="number" class="dmf-range-min" placeholder="Min" min="${min}" max="${max}" step="0.01">
            <span>—</span>
            <input type="number" class="dmf-range-max" placeholder="Max" min="${min}" max="${max}" step="0.01">
          </div>
          <small class="dmf-range-hint">Range: ${min} – ${max}</small>
        </div>
      `;
      this.filtersEl.appendChild(group);
    }

    bindEvents() {
      this.filtersEl.addEventListener('change', e => {
        if (e.target.classList.contains('dmf-check')) this.updateCheckboxFilter(e.target);
        else if (e.target.classList.contains('dmf-range-min') || e.target.classList.contains('dmf-range-max')) this.updateRangeFilter(e.target);
      });

      this.filtersEl.addEventListener('input', e => {
        if (e.target.classList.contains('dmf-filter-search')) {
          const term = e.target.value.toLowerCase();
          const list = e.target.parentElement.querySelector('.dmf-check-list');
          list.querySelectorAll('.dmf-check-item').forEach(item => {
            item.style.display = item.textContent.toLowerCase().includes(term) ? '' : 'none';
          });
        }
        if (e.target.classList.contains('dmf-range-min') || e.target.classList.contains('dmf-range-max')) {
          clearTimeout(this._rangeTimer);
          this._rangeTimer = setTimeout(() => this.updateRangeFilter(e.target), 400);
        }
      });

      this.filtersEl.addEventListener('click', e => {
        const toggle = e.target.closest('.dmf-filter-toggle');
        if (toggle) {
          const body = toggle.nextElementSibling;
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !expanded);
          body.style.display = expanded ? 'none' : '';
        }
      });

      this.wrapper.querySelectorAll('.dmf-clear-all').forEach(btn => {
        btn.addEventListener('click', () => this.clearAll());
      });

      this.sortEl.addEventListener('change', () => { this.currentPage = 1; this.applyFilters(); });
      this.perPageEl.addEventListener('change', () => {
        this.perPage = parseInt(this.perPageEl.value, 10);
        this.currentPage = 1;
        this.applyFilters();
      });

      // ── Mobile sidebar open/close ──────────────────────────────────
      const mobileBtn = this.wrapper.querySelector('.dmf-mobile-toggle');
      const sidebar = this.wrapper.querySelector('.dmf-sidebar');
      const backdrop = document.getElementById(`dmf-backdrop-${this.sectionId}`);
      const applyBtn = document.getElementById(`dmf-apply-${this.sectionId}`);

      const openSidebar = () => {
        sidebar.classList.add('dmf-open');
        if (backdrop) backdrop.classList.add('dmf-backdrop-visible');
        document.body.style.overflow = 'hidden';
      };

      const closeSidebar = () => {
        sidebar.classList.remove('dmf-open');
        if (backdrop) backdrop.classList.remove('dmf-backdrop-visible');
        document.body.style.overflow = '';
      };

      if (mobileBtn) mobileBtn.addEventListener('click', openSidebar);
      if (backdrop)  backdrop.addEventListener('click', closeSidebar);
      if (applyBtn)  applyBtn.addEventListener('click', () => {
        closeSidebar();
        setTimeout(() => {
          this.gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
      // ──────────────────────────────────────────────────────────────

      this.paginationEl.addEventListener('click', e => {
        const btn = e.target.closest('[data-page]');
        if (btn) {
          this.currentPage = parseInt(btn.dataset.page, 10);
          this.applyFilters();
          this.wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    updateCheckboxFilter(checkbox) {
      const group = checkbox.closest('.dmf-filter-group');
      const key = group.dataset.key;
      const checked = Array.from(group.querySelectorAll('.dmf-check:checked')).map(c => c.value);
      if (checked.length) this.activeFilters[key] = { type: 'checkbox', values: checked };
      else delete this.activeFilters[key];
      this.currentPage = 1;
      this.applyFilters();
    }

    updateRangeFilter(input) {
      const group = input.closest('.dmf-filter-group');
      const key = group.dataset.key;
      const min = parseFloat(group.querySelector('.dmf-range-min').value);
      const max = parseFloat(group.querySelector('.dmf-range-max').value);
      if (!isNaN(min) || !isNaN(max)) {
        this.activeFilters[key] = { type: 'range', min: isNaN(min) ? -Infinity : min, max: isNaN(max) ? Infinity : max };
      } else delete this.activeFilters[key];
      this.currentPage = 1;
      this.applyFilters();
    }

    productMatches(product, key, filter) {
      if (key === PRICE_FILTER_KEY) {
        const price = parseFloat(product.price);
        if (isNaN(price)) return false;
        if (filter.type === 'range') return price >= filter.min && price <= filter.max;
        return true;
      }
      let val = product.metafields ? product.metafields[key] : null;
      if (val === null || val === undefined || val === '') return false;
      if (typeof val === 'string' && (val.startsWith('[') || val.startsWith('{'))) {
        try { val = JSON.parse(val); } catch {}
      }
      const values = Array.isArray(val) ? val.map(String) : [String(val.value !== undefined ? val.value : val)];
      if (filter.type === 'checkbox') return filter.values.some(fv => values.includes(fv));
      if (filter.type === 'range') {
        return values.some(v => { const n = parseFloat(v); return !isNaN(n) && n >= filter.min && n <= filter.max; });
      }
      return true;
    }

    applyFilters() {
      const isFiltering = Object.keys(this.activeFilters).length > 0;
      let filtered = this.products.filter(p =>
        Object.keys(this.activeFilters).every(key => this.productMatches(p, key, this.activeFilters[key]))
      );
      const sort = this.sortEl.value;
      if (sort === 'price-asc') filtered.sort((a, b) => a.price - b.price);
      else if (sort === 'price-desc') filtered.sort((a, b) => b.price - a.price);
      else if (sort === 'title-asc') filtered.sort((a, b) => a.title.localeCompare(b.title));
      else if (sort === 'title-desc') filtered.sort((a, b) => b.title.localeCompare(a.title));
      this.filteredProducts = filtered;
      this.renderPage();
      this.renderPagination();
      this.updateCounts(isFiltering);
      this.syncURL();
    }

    renderPage() {
      const total = this.filteredProducts.length;
      const totalPages = Math.max(1, Math.ceil(total / this.perPage));
      if (this.currentPage > totalPages) this.currentPage = totalPages;
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      const pageProducts = this.filteredProducts.slice(start, end);
      if (total === 0) { this.gridEl.innerHTML = ''; this.emptyEl.style.display = ''; return; }
      this.emptyEl.style.display = 'none';
      this.gridEl.innerHTML = pageProducts.map(p => this.cardHTML(p)).join('');
      if (this.imageObserver) {
        this.gridEl.querySelectorAll('img[data-src]').forEach(img => this.imageObserver.observe(img));
      } else {
        this.gridEl.querySelectorAll('img[data-src]').forEach(img => {
          img.src = img.dataset.src; img.removeAttribute('data-src');
        });
      }
    }

    cardHTML(p) {
      const imgHtml = p.image
        ? `<img data-src="${this.escape(p.image)}" alt="${this.escape(p.imageAlt || '')}" class="dmf-card-img" loading="lazy">`
        : '<div class="dmf-card-img dmf-card-img-empty"></div>';
      const compareAt = p.compareAt ? `<span class="dmf-card-compare">${p.compareAt}</span>` : '';
      const soldOut = !p.available ? '<span class="dmf-card-soldout">Sold Out</span>' : '';
      return `
        <article class="dmf-card" data-product-id="${p.id}">
          <a href="${this.escape(p.url)}" class="dmf-card-link">
            <div class="dmf-card-img-wrap">${imgHtml}${soldOut}</div>
            <div class="dmf-card-body">
              <h4 class="dmf-card-title">${this.escape(p.title)}</h4>
              <p class="dmf-card-price"><span>${p.priceFormatted}</span>${compareAt}</p>
            </div>
          </a>
        </article>`;
    }

    renderPagination() {
      const total = this.filteredProducts.length;
      const totalPages = Math.ceil(total / this.perPage);
      if (totalPages <= 1) { this.paginationEl.innerHTML = ''; return; }
      const current = this.currentPage;
      let html = '';
      html += current > 1
        ? `<button class="dmf-page-btn" data-page="${current - 1}">‹ Prev</button>`
        : `<button class="dmf-page-btn dmf-page-disabled" disabled>‹ Prev</button>`;
      this.getPageNumbers(current, totalPages).forEach(p => {
        if (p === '...') html += `<span class="dmf-page-ellipsis">…</span>`;
        else html += p === current
          ? `<button class="dmf-page-btn dmf-page-current" data-page="${p}">${p}</button>`
          : `<button class="dmf-page-btn" data-page="${p}">${p}</button>`;
      });
      html += current < totalPages
        ? `<button class="dmf-page-btn" data-page="${current + 1}">Next ›</button>`
        : `<button class="dmf-page-btn dmf-page-disabled" disabled>Next ›</button>`;
      this.paginationEl.innerHTML = html;
    }

    getPageNumbers(current, total) {
      const pages = []; const delta = 2;
      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) pages.push(i);
        else if (pages[pages.length - 1] !== '...') pages.push('...');
      }
      return pages;
    }

    updateCounts(isFiltering) {
      const filteredTotal = this.filteredProducts.length;
      const start = filteredTotal === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(start + this.perPage - 1, filteredTotal);
      const grandTotal = this.expectedTotal || this.totalProducts || this.products.length;
      let mainText;
      if (!isFiltering) mainText = `${grandTotal} products`;
      else if (filteredTotal === 0) mainText = `0 products match`;
      else mainText = `Showing ${start}–${end} of ${filteredTotal} matching products`;
      this.countEl.textContent = mainText;

      this.filtersEl.querySelectorAll('.dmf-filter-group').forEach(group => {
        const key = group.dataset.key;
        if (key === PRICE_FILTER_KEY) return;
        group.querySelectorAll('.dmf-count').forEach(span => {
          const val = span.dataset.value;
          const others = {...this.activeFilters};
          delete others[key];
          const count = this.products.filter(p =>
            Object.keys(others).every(k => this.productMatches(p, k, others[k])) &&
            this.productMatches(p, key, { type: 'checkbox', values: [val] })
          ).length;
          span.textContent = `(${count})`;
        });
      });
    }

    clearAll() {
      this.activeFilters = {};
      this.filtersEl.querySelectorAll('.dmf-check').forEach(c => c.checked = false);
      this.filtersEl.querySelectorAll('.dmf-range-min, .dmf-range-max').forEach(i => i.value = '');
      this.sortEl.value = 'default';
      this.currentPage = 1;
      this.applyFilters();
    }

    syncURL() {
      const params = new URLSearchParams();
      Object.keys(this.activeFilters).forEach(key => {
        const f = this.activeFilters[key];
        if (f.type === 'checkbox') params.set(`f.${key}`, f.values.join('|'));
        else if (f.type === 'range') {
          if (f.min !== -Infinity) params.set(`f.${key}.min`, f.min);
          if (f.max !== Infinity) params.set(`f.${key}.max`, f.max);
        }
      });
      if (this.sortEl.value !== 'default') params.set('sort', this.sortEl.value);
      if (this.currentPage > 1) params.set('page', this.currentPage);
      if (this.perPage !== DEFAULT_PER_PAGE) params.set('per_page', this.perPage);
      const newUrl = params.toString() ? `${location.pathname}?${params}` : location.pathname;
      history.replaceState(null, '', newUrl);
    }

    loadFromURL() {
      const params = new URLSearchParams(location.search);
      params.forEach((val, key) => {
        if (key === 'sort') { this.sortEl.value = val; return; }
        if (key === 'page') { this.currentPage = parseInt(val, 10) || 1; return; }
        if (key === 'per_page') {
          const parsed = parseInt(val, 10);
          const validPerPages = [24, 48, 72, 96];
          this.perPage = validPerPages.includes(parsed) ? parsed : DEFAULT_PER_PAGE;
          this.perPageEl.value = this.perPage;
          return;
        }
        if (!key.startsWith('f.')) return;
        if (key.endsWith('.min') || key.endsWith('.max')) {
          const baseKey = key.slice(2, key.lastIndexOf('.'));
          const which = key.endsWith('.min') ? 'min' : 'max';
          const group = this.filtersEl.querySelector(`[data-key="${baseKey}"]`);
          if (group) { const input = group.querySelector(`.dmf-range-${which}`); if (input) input.value = val; }
        } else {
          const baseKey = key.slice(2);
          const values = val.split('|');
          const group = this.filtersEl.querySelector(`[data-key="${baseKey}"]`);
          if (group) {
            values.forEach(v => {
              const cb = group.querySelector(`.dmf-check[value="${CSS.escape(v)}"]`);
              if (cb) cb.checked = true;
            });
            this.activeFilters[baseKey] = { type: 'checkbox', values };
          }
        }
      });
      this.filtersEl.querySelectorAll('.dmf-filter-group').forEach(group => {
        const minEl = group.querySelector('.dmf-range-min');
        if (minEl) this.updateRangeFilter(minEl);
      });
    }

    humanize(key) {
      return key.split('.').pop().replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }

    escape(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-dmf-section]').forEach(el => {
      if (!el._dmfInit) el._dmfInit = new DynamicMetafieldFilter(el);
    });
  });

  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('[data-dmf-section]');
    if (el && !el._dmfInit) el._dmfInit = new DynamicMetafieldFilter(el);
  });
})();
